import { AxiosError, AxiosResponse } from 'axios';
import { appConfig } from '../../config';
import { log } from '../utils/log';
import i18n from '../../../i18n';
import { http } from '../../api/axios';
import { showNotification } from './toastNotification';

export const TYPE_WARNING = 'warning';
export const TYPE_ERROR = 'error';

export interface RuntimeDuplicationError {
    runtimeDuplication?: boolean;
    response: AxiosResponse;
    error: AxiosResponse;
}

export type ErrorResponse = AxiosError | AxiosResponse | RuntimeDuplicationError | string;

export function isErrorOfType(error: any): error is ErrorResponse {
    if (typeof error === 'string') {
        return true;
    } else if (error && error.isAxiosError) {
        return true;
    } else if (error && error.status && error.data) {
        return true;
    } else if (error && error.runtimeDuplication) {
        return true;
    }
    return false;
}

export function globalError(errorResponse: ErrorResponse, displayNotification?: boolean) {
    return globalWarningOrError(errorResponse, TYPE_ERROR, displayNotification);
}

export function globalWarning(errorResponse: ErrorResponse, displayNotification?: boolean) {
    return globalWarningOrError(errorResponse, TYPE_WARNING, displayNotification);
}

export function globalErrorResponse(errorResponse: ErrorResponse, displayNotification?: boolean) {
    let status = 999;
    if ((errorResponse as AxiosError).response) {
        status = (errorResponse as AxiosError).response?.status ?? 999;
    }
    if ((errorResponse as AxiosResponse).status) {
        status = (errorResponse as AxiosResponse).status;
    }

    const type = status >= 400 && status <= 499 ? TYPE_WARNING : TYPE_ERROR;
    const showNotification = type === TYPE_WARNING ? displayNotification : true;
    return globalWarningOrError(errorResponse, type, showNotification);
}

function globalWarningOrError(errorResponse: ErrorResponse, type, displayNotification = true) {
    if ((errorResponse as RuntimeDuplicationError).runtimeDuplication) {
        return;
    }

    let msg = '';
    let status = 0;
    if ((errorResponse as AxiosError).response) {
        const resp = (errorResponse as AxiosError).response as AxiosResponse;
        msg = resp.data ? resp.data.message || i18n.t('notifications.globalErrorResponse.errorMessage') : resp;
        status = resp.status;
    } else if ((errorResponse as AxiosResponse).status) {
        const resp = errorResponse as AxiosResponse;
        msg = resp.data ? resp.data.message || i18n.t('notifications.globalErrorResponse.errorMessage') : resp;
        status = resp.status;
    } else {
        msg = errorResponse as string;
    }

    if (type === TYPE_ERROR) {
        log.warning(msg);
        msg = i18n.t('notifications.globalErrorResponse.tryAgain', { msg });
    } else {
        log.warning(msg);
    }

    if (status >= 500) {
        http.get(appConfig().endpointHealth)
            .then(() => showNotification(msg, TYPE_ERROR))
            .catch(() => {
                window.location.assign('/maintenance');
            });
    } else if (displayNotification) {
        showNotification(msg, type);
    }
}
